/*
  Jane Lushka v1.2 collection page (phase 4: collection:2, 3, 8, M1, M4; K5 to K9, K26, K31, K34).
  Loaded with defer by sections/main-collection-product-grid.liquid. No global API: one controller per
  [data-jl-collection], re-created on shopify:section:load; every listener is delegated on document or window.

  State: the URL is the only state (K7). Filter, sort and In stock changes edit a URLSearchParams copy, then fetch THIS
  section (location.pathname + ?<params>&section_id=<id>), replace the [data-jl-region] nodes (count, chips, grid,
  more, pill, sheet) from the response (DOMParser), restore focus by id and history.pushState the new URL. Checkbox and
  size chip changes are debounced 400 ms; Apply (price), remove x, Clear all, Clear and sort apply at once. The last
  response wins (AbortController). The live region is never replaced: its text comes from the response's
  data-jl-live-results. Filter and sort changes drop `page`.
  Load more (K6): one button, fetches page N of this section, appends its li.jl-grid__item cells (never the tile),
  re-applies the hold-back (K5: with the tile on page 1, the last card of the highest loaded page carries
  data-jl-hold unless that page is the last one), replaces the "more" region, replaceState page=N, focuses the first
  newly visible card's name link (.jl-card__link) and announces the new sentence. Landing on page=N > 1: pages 1 to N-1
  are fetched and prepended (page 1 brings the tile), then the scroll position saved in sessionStorage
  jl:coll-pos:<pathname + search without page> = {page, handle, y, top} is restored (back/forward and reload only).
  Popovers >= 768 (role dialog, Escape, outside click or the chip again closes, focus back to the chip); < 768 chips
  and the M4 pill open the filter sheet (modal: focus trap, Escape, backdrop, inert page with the phase 3 algorithm,
  body.jl-fsheet-open). The pill shows when the chip row has scrolled above the viewport and neither the sheet, the
  bag, the size sheet nor the load more block or the footer is in the way.
  Density (K4, collection:3): html[data-jl-cols] + localStorage jl:grid-cols:v1, no fetch, URL untouched.
  Remembered size (K26): window.JLSizeSheet.rememberSize / rememberedSize, localStorage jl:size:v1 as fallback.
  Events on document (bubbles): jl:filter-change {param, value, action, surface}, jl:sort-change {value, surface},
  jl:grid-view {columns}, jl:load-more {page, seen, total}, jl:filter-sheet-open {source},
  jl:collection-render {reason, count (products matching the current filters)}. Filter and sort events fire after
  pushState, so GA4 reads the new page_location.
  Every storage access is wrapped in try/catch.
  Review fixes (fixer B): arrow keys in the open sort popover apply at once but make one history entry, one
  jl:sort-change and one announcement when the popover closes (Escape, Tab out, Enter); load more keeps focus on its
  button (aria-disabled while loading, focus back on it after an error); the phone sheet body is stamped from its
  <template> on first open; the last 10 section responses are kept in memory (Back/Forward and returning to a state
  cost no request; dropped after a quick add, a back/forward cache restore, a theme editor reload or 5 minutes); card
  image sizes follow 3 or 4 per row; below 768px the group chips point at the sheet (no aria-expanded);
  html.jl-pill-on while the pill shows (scroll padding).
  Filter fixes (P10): focus that lands on an ancestor of an open popover (main[tabindex=-1] after a press on an
  option's label text; any control in Safari) does not close it, so the click applies; a popover re-opened after a
  render keeps its scroll position; a failed update logs a console warning and shows [data-jl-toast] for 5 s.
  Phase 5 (K9 to K15): the brand row (region "brand", snippets/jl-brand-row.liquid) and the sheet's Brand group.
  A click on a brand chip (.jl-bchip[data-jl-brand], never any [data-jl-brand]: product cards carry that attribute
  too) replaces every filter.p.vendor value with the chosen one (none for All brands), drops page, queues
  jl:filter-change {param: 'filter.p.vendor', value, action add|remove, surface brand_row|sheet} and fetches at once
  (no debounce); focus comes back to the chip with the same id (jl-bchip-<surface>-<handle>). The choice is kept in
  sessionStorage jl:brand:v1 when the row allows it (data-jl-brand-mem="true"): set on a brand, removed on All
  brands and by the empty-results button. On the next collection layout/theme.liquid reloads the page filtered from
  the top of <head> (K15; reviews F1, C2) and leaves sessionStorage jl:brand:shown: init announces "Showing <brand>
  only" once in the live region (review A3). Brand page chips (data-jl-brand-nav) navigate; they only update the
  memory, and the page's own (aria-current) chip does nothing (review C7). A modified or middle click on a chip link
  keeps the browser default (new tab) and the memory (review C5). Clear all and the sheet Clear keep filter.p.vendor;
  the empty-results button (data-jl-clear-all="everything") clears it too. The sheet Clear carries
  aria-disabled="true" while no filter other than the brand is chosen (review A5).
*/
(function () {
  'use strict';

  if (window.__jlCollection) return;
  window.__jlCollection = 1;

  var DEBOUNCE_MS = 400;
  var COLS_KEY = 'jl:grid-cols:v1';
  var SIZE_KEY = 'jl:size:v1';
  var POS_KEY = 'jl:coll-pos:';
  var SIZE_PARAM = 'filter.v.option.size';
  var AVAIL_PARAM = 'filter.v.availability';
  var VENDOR_PARAM = 'filter.p.vendor';
  var BRAND_KEY = 'jl:brand:v1';
  var SHOWN_KEY = 'jl:brand:shown';
  var MAX_RESTORE_PAGES = 30;
  var SKIP_INERT = /^(SCRIPT|STYLE|LINK|META|TEMPLATE|NOSCRIPT)$/;
  var REGIONS = ['count', 'brand', 'chips', 'grid', 'more', 'pill', 'sheet'];
  var COPY_ATTRS = ['data-total', 'data-page', 'data-pages', 'data-page-size', 'data-has-tile', 'data-load-more',
    'data-applied', 'data-jl-live-results'];
  var FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), ' +
    'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var CACHE_MAX = 10;
  var CACHE_MS = 5 * 60 * 1000;

  // monotonic ms for the pointer window and the cache age (a pinned or changed wall clock does not move it)
  function nowMs() {
    return window.performance && performance.now ? performance.now() : Date.now();
  }

  var controllers = [];
  var lastPointerAt = 0;
  var cache = []; // { url, html, t }, least recently used first
  var deskMq = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;

  /* ---------- helpers ---------- */
  function isDesk() {
    return deskMq ? deskMq.matches : (window.innerWidth || 0) >= 768;
  }

  function visible(el) {
    return !!(el && document.documentElement.contains(el) && el.getClientRects().length);
  }

  function focusEl(el, scroll) {
    if (!el) return;
    try { el.focus({ preventScroll: !scroll }); } catch (e) { try { el.focus(); } catch (e2) { /* noop */ } }
  }

  function dispatch(name, detail) {
    var ev;
    try {
      ev = new CustomEvent(name, { bubbles: true, detail: detail });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(name, true, false, detail);
    }
    document.dispatchEvent(ev);
  }

  function cssEsc(s) {
    s = String(s);
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(s);
    return s.replace(/["\\\[\]]/g, '\\$&');
  }

  function int(v, d) {
    var n = parseInt(v, 10);
    return isNaN(n) ? (d || 0) : n;
  }

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* storage blocked */ } }

  function newCtrl() {
    return typeof window.AbortController === 'function' ? new window.AbortController() : { abort: function () {}, signal: null };
  }

  function cloneParams(p) {
    return new URLSearchParams(p.toString());
  }

  // the filter, sort and unknown params without page and section_id
  function stripParams(p) {
    var c = cloneParams(p);
    c.delete('page');
    c.delete('section_id');
    return c;
  }

  // order-independent key of a state (page excluded)
  function keyOf(p) {
    var arr = [];
    stripParams(p).forEach(function (v, k) { arr.push(k + '=' + v); });
    arr.sort();
    return arr.join('&');
  }

  function hasValue(params, key, value) {
    return params.getAll(key).indexOf(value) >= 0;
  }

  function removeValue(params, key, value) {
    var keep = params.getAll(key).filter(function (v) { return v !== value; });
    params.delete(key);
    keep.forEach(function (v) { params.append(key, v); });
  }

  // a group's keys: the param itself and its sub keys (filter.v.price -> filter.v.price.gte / .lte)
  function groupKeys(params, key) {
    var keys = [];
    params.forEach(function (v, k) {
      if ((k === key || k.indexOf(key + '.') === 0) && keys.indexOf(k) < 0) keys.push(k);
    });
    return keys;
  }

  function cleanNum(v) {
    v = String(v == null ? '' : v).trim().replace(',', '.');
    if (v === '') return '';
    var n = parseFloat(v);
    if (isNaN(n) || n < 0) return '';
    return String(n);
  }

  function navType() {
    try {
      var e = window.performance.getEntriesByType('navigation');
      if (e && e[0] && e[0].type) return e[0].type;
    } catch (err) { /* old browser */ }
    try {
      var t = window.performance.navigation.type;
      return t === 2 ? 'back_forward' : (t === 1 ? 'reload' : 'navigate');
    } catch (err2) { /* noop */ }
    return 'navigate';
  }

  function rememberedSize() {
    try {
      if (window.JLSizeSheet && typeof window.JLSizeSheet.rememberedSize === 'function') {
        var s = window.JLSizeSheet.rememberedSize();
        if (s) return String(s);
      }
    } catch (e) { /* SHEET not ready */ }
    return lsGet(SIZE_KEY) || '';
  }

  function rememberSize(size) {
    if (!size) return;
    try {
      if (window.JLSizeSheet && typeof window.JLSizeSheet.rememberSize === 'function') {
        window.JLSizeSheet.rememberSize(size);
        return;
      }
    } catch (e) { /* fall back to storage */ }
    lsSet(SIZE_KEY, size);
  }

  // instant scroll: the theme sets scroll-behavior: smooth on html, which would animate restores and anchoring
  function jumpTo(y) {
    var el = document.documentElement;
    var prev = el.style.scrollBehavior;
    el.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.max(0, Math.round(y)));
    el.style.scrollBehavior = prev;
  }

  // page=N entries restore their own position (K6), so the browser must not restore an older one first
  function setScrollRestoration(mode) {
    try { if ('scrollRestoration' in window.history) window.history.scrollRestoration = mode; } catch (e) { /* noop */ }
  }

  function pageUrl(params) {
    var s = params.toString();
    return window.location.pathname + (s ? '?' + s : '');
  }

  /* section responses by URL (review F7); a locale or currency change loads a new page, which starts empty */
  function cacheGet(url) {
    for (var i = 0; i < cache.length; i++) {
      if (cache[i].url !== url) continue;
      var hit = cache.splice(i, 1)[0];
      if (nowMs() - hit.t > CACHE_MS) return null;
      cache.push(hit);
      return hit.html;
    }
    return null;
  }

  function cachePut(url, html) {
    for (var i = cache.length - 1; i >= 0; i--) if (cache[i].url === url) cache.splice(i, 1);
    cache.push({ url: url, html: html, t: nowMs() });
    while (cache.length > CACHE_MAX) cache.shift();
  }

  /* ---------- K31: header height for the sticky chip band ---------- */
  var headerRO = null;
  var headerQueued = false;
  var headerWatched = [];

  function headerEls() {
    return [
      document.getElementById('shopify-section-announcement-bar'),
      document.getElementById('shopify-section-header') ||
        document.querySelector('.shopify-section-group-header-group') ||
        document.querySelector('header')
    ];
  }

  // bottom edge of a sticky or fixed bar while it sticks (its top offset plus its height); 0 when it scrolls away
  function stickyBottom(el) {
    if (!el) return 0;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none') return 0;
    if (cs.position !== 'sticky' && cs.position !== '-webkit-sticky' && cs.position !== 'fixed') return 0;
    var top = parseFloat(cs.top);
    if (isNaN(top)) top = 0;
    return top + el.getBoundingClientRect().height;
  }

  function measureHeader() {
    headerQueued = false;
    var els = headerEls();
    var h = 0;
    for (var i = 0; i < els.length; i++) h = Math.max(h, stickyBottom(els[i]));
    document.documentElement.style.setProperty('--jl-header-h', Math.round(h) + 'px');
  }

  function queueHeader() {
    if (headerQueued) return;
    headerQueued = true;
    window.requestAnimationFrame(measureHeader);
  }

  function watchHeader() {
    var els = headerEls();
    if (!headerRO && typeof window.ResizeObserver === 'function') headerRO = new window.ResizeObserver(queueHeader);
    if (headerRO) {
      for (var i = 0; i < headerWatched.length; i++) headerRO.unobserve(headerWatched[i]);
      headerWatched = [];
      for (var j = 0; j < els.length; j++) {
        if (els[j]) {
          headerRO.observe(els[j]);
          headerWatched.push(els[j]);
        }
      }
    }
    queueHeader();
  }

  /* ---------- controller ---------- */
  function Controller(root) {
    this.root = root;
    this.id = root.getAttribute('data-section-id') || '';
    this.params = new URLSearchParams(window.location.search);
    this.renderedKey = keyOf(this.params);
    this.queue = [];
    this.timer = null;
    this.reason = 'filter';
    this.ctrl = null;
    this.moreCtrl = null;
    this.restoreCtrl = null;
    this.popParam = null;
    this.sheetOpen = false;
    this.sheetOpener = null;
    this.sheetOpenerId = '';
    this.inerted = [];
    this.instockPending = false;
    this.focusFallback = '';
    this.liveTimer = null;
    this.toastTimer = null;
    this.clickSavedAt = 0;
    this.sortKeys = null;
    this.pill = { past: false, more: false, footer: false };
    this.io = null;
    this.sentinel = null;
    this.moreEl = null;
    this.footer = null;
    this.init();
  }

  Controller.prototype.init = function () {
    this.syncCols();
    this.syncChipAria();
    this.syncInstock();
    this.applyHold();
    this.observePill();
    this.restore();
    this.announceMemory();
  };

  Controller.prototype.destroy = function () {
    clearTimeout(this.timer);
    clearTimeout(this.liveTimer);
    clearTimeout(this.toastTimer);
    this.timer = null;
    this.abortAll();
    if (this.io) this.io.disconnect();
    this.inertPage(false);
    if (this.sheetOpen) document.body.classList.remove('jl-fsheet-open');
    this.sheetOpen = false;
    this.sortKeys = null;
    document.documentElement.classList.remove('jl-pill-on');
  };

  Controller.prototype.grid = function () {
    return this.root.querySelector('[data-jl-grid]');
  };

  Controller.prototype.total = function () {
    return int(this.root.getAttribute('data-total'), 0);
  };

  Controller.prototype.highestPage = function () {
    var max = int(this.root.getAttribute('data-page'), 1);
    var grid = this.grid();
    if (!grid) return max;
    var items = grid.querySelectorAll('.jl-grid__item[data-jl-page]');
    for (var i = 0; i < items.length; i++) max = Math.max(max, int(items[i].getAttribute('data-jl-page'), 1));
    return max;
  };

  Controller.prototype.surfaceOf = function (el) {
    return el && el.closest && el.closest('[data-jl-filter-sheet]') ? 'sheet' : 'chip';
  };

  Controller.prototype.queueEvent = function (name, detail) {
    this.queue.push({ name: name, detail: detail });
  };

  Controller.prototype.announce = function (text, delay) {
    var live = this.root.querySelector('[data-jl-live]');
    if (!live || !text) return;
    live.textContent = '';
    clearTimeout(this.liveTimer);
    this.liveTimer = setTimeout(function () { live.textContent = text; }, delay || 60);
  };

  // a failed update is undone: say so on screen too (the live region tells screen readers; the toast is aria-hidden)
  Controller.prototype.toast = function (text) {
    var el = this.root.querySelector('[data-jl-toast]');
    clearTimeout(this.toastTimer);
    if (!el) return;
    if (!text) {
      el.hidden = true;
      return;
    }
    el.textContent = text;
    el.hidden = false;
    this.toastTimer = setTimeout(function () { el.hidden = true; }, 5000);
  };

  Controller.prototype.setBusy = function (on) {
    var els = [this.root.querySelector('[data-jl-region="grid"]'), this.grid(), this.root.querySelector('[data-jl-show-results]')];
    for (var i = 0; i < els.length; i++) {
      if (!els[i]) continue;
      if (on) els[i].setAttribute('aria-busy', 'true');
      else els[i].removeAttribute('aria-busy');
    }
  };

  /* ---------- K5 hold-back ---------- */
  Controller.prototype.applyHold = function () {
    var grid = this.grid();
    if (!grid) return;
    var held = grid.querySelectorAll('[data-jl-hold]');
    for (var i = 0; i < held.length; i++) held[i].removeAttribute('data-jl-hold');
    if (this.root.getAttribute('data-has-tile') !== 'true' || !grid.querySelector('[data-jl-tile]')) return;
    if (this.highestPage() >= int(this.root.getAttribute('data-pages'), 1)) return;
    var items = grid.querySelectorAll('.jl-grid__item');
    if (items.length) items[items.length - 1].setAttribute('data-jl-hold', '');
  };

  /* ---------- density toggle (collection:3) ---------- */
  Controller.prototype.syncCols = function () {
    var cols = document.documentElement.getAttribute('data-jl-cols') || '3';
    var btns = this.root.querySelectorAll('[data-jl-cols-toggle] [data-cols]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-cols') === cols ? 'true' : 'false');
    }
    this.syncSizes();
  };

  // card image sizes for the columns on screen (the grid carries both strings; the server used the section default).
  // scope: cells not in the grid yet (load more / restore set them before inserting, so no image is fetched twice)
  Controller.prototype.syncSizes = function (scope) {
    var grid = this.grid();
    if (!grid) return;
    var sizes = grid.getAttribute(document.documentElement.getAttribute('data-jl-cols') === '4' ? 'data-jl-sizes-4' : 'data-jl-sizes-3');
    if (!sizes) return;
    var imgs = (scope || grid).querySelectorAll('.jl-card__img, .jl-card__img2');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('sizes') !== sizes) imgs[i].setAttribute('sizes', sizes);
    }
  };

  Controller.prototype.setCols = function (cols) {
    if (cols !== '3' && cols !== '4') return;
    var html = document.documentElement;
    var prev = html.getAttribute('data-jl-cols');
    html.setAttribute('data-jl-cols', cols);
    lsSet(COLS_KEY, cols);
    for (var i = 0; i < controllers.length; i++) controllers[i].syncCols();
    if (prev !== cols) dispatch('jl:grid-view', { columns: int(cols, 3) });
  };

  /* ---------- In stock in my size (K26) ---------- */
  // the remembered size when it is a value of the Size filter (in its own spelling), else ""
  Controller.prototype.validRemembered = function () {
    var r = rememberedSize();
    if (!r) return '';
    var low = r.toLowerCase();
    var opts = this.root.querySelectorAll('[data-jl-param="' + SIZE_PARAM + '"]');
    for (var i = 0; i < opts.length; i++) {
      var v = opts[i].getAttribute('value') || '';
      if (v.toLowerCase() === low) return v;
    }
    return '';
  };

  Controller.prototype.syncInstock = function () {
    var inputs = this.root.querySelectorAll('[data-jl-instock]');
    if (!inputs.length) return;
    var on = hasValue(this.params, AVAIL_PARAM, '1');
    var sizes = this.params.getAll(SIZE_PARAM);
    var size = on ? (sizes.length === 1 ? sizes[0] : '') : this.validRemembered();
    var tpl = this.root.getAttribute('data-jl-label-instock-size') || '';
    var text = size && tpl.indexOf('JLSIZE') >= 0 ? tpl.replace('JLSIZE', size) : (this.root.getAttribute('data-jl-label-instock') || '');
    var labels = this.root.querySelectorAll('[data-jl-instock-label]');
    var i;
    for (i = 0; i < labels.length; i++) {
      if (text && labels[i].textContent !== text) labels[i].textContent = text;
    }
    for (i = 0; i < inputs.length; i++) {
      inputs[i].checked = on;
      var lab = inputs[i].closest('label');
      if (lab) lab.classList.toggle('is-checked', on);
    }
  };

  // option inputs and size chips follow the pending state (keeps the popover and the sheet in step, reverts on error)
  Controller.prototype.syncInputs = function () {
    var self = this;
    var opts = this.root.querySelectorAll('[data-jl-param]');
    for (var i = 0; i < opts.length; i++) {
      var el = opts[i];
      var param = el.getAttribute('data-jl-param');
      var value = el.getAttribute('value') || '';
      if (el.tagName === 'INPUT' && el.type === 'checkbox') el.checked = hasValue(self.params, param, value);
      else if (el.classList.contains('jl-szchip')) el.setAttribute('aria-pressed', hasValue(self.params, param, value) ? 'true' : 'false');
    }
    this.syncInstock();
    this.syncBrand();
    this.syncClear();
  };

  // the sheet's Clear keeps the brand (K14): with no other filter chosen it would do nothing, so it is shown as
  // unavailable (aria-disabled, still focusable) instead of a button that silently does nothing (review A5)
  Controller.prototype.syncClear = function () {
    var btn = this.root.querySelector('[data-jl-sheet-clear]');
    if (!btn) return;
    var any = false;
    this.params.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 && k !== VENDOR_PARAM) any = true;
    });
    if (any) btn.removeAttribute('aria-disabled');
    else btn.setAttribute('aria-disabled', 'true');
  };

  /* ---------- phase 5 brand row (K9 to K15) ---------- */
  // filter chips (not brand page links) follow the pending vendor value: one value -> that brand, else All brands
  Controller.prototype.syncBrand = function () {
    var vals = this.params.getAll(VENDOR_PARAM);
    var cur = vals.length === 1 ? vals[0] : '';
    var chips = this.root.querySelectorAll('.jl-bchip[data-jl-brand]:not([data-jl-brand-nav])');
    var i;
    var known = false;
    for (i = 0; i < chips.length; i++) if ((chips[i].getAttribute('data-jl-brand') || '') === cur) known = true;
    // a value of no chip (the gift card vendor in a hand-made URL) shows as All brands, as the server renders it
    if (!known) cur = '';
    for (i = 0; i < chips.length; i++) {
      var on = (chips[i].getAttribute('data-jl-brand') || '') === cur;
      if (chips[i].tagName === 'BUTTON') chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      else if (on) chips[i].setAttribute('aria-current', 'true');
      else chips[i].removeAttribute('aria-current');
    }
  };

  Controller.prototype.onBrand = function (e, chip) {
    // Cmd, Ctrl, Shift or Alt click (or a non-primary button) on a link: the browser opens it, nothing else changes
    if (chip.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0)) return;
    // the brand page's own chip is this page: no reload, its filters and sort stay
    if (chip.hasAttribute('data-jl-brand-nav') && chip.hasAttribute('aria-current')) {
      e.preventDefault();
      return;
    }
    var value = chip.getAttribute('data-jl-brand') || '';
    var row = chip.closest('[data-jl-brandrow]');
    if (row && row.getAttribute('data-jl-brand-mem') === 'true') {
      if (value) ssSet(BRAND_KEY, value);
      else ssDel(BRAND_KEY);
    }
    // brand page (K13): the browser follows the link
    if (chip.hasAttribute('data-jl-brand-nav')) return;
    e.preventDefault();
    var cur = this.params.getAll(VENDOR_PARAM);
    if (value ? cur.length === 1 && cur[0] === value : !cur.length) return;
    this.params.delete(VENDOR_PARAM);
    if (value) this.params.append(VENDOR_PARAM, value);
    this.params.delete('page');
    this.queueEvent('jl:filter-change', {
      param: VENDOR_PARAM,
      value: value,
      action: value ? 'add' : 'remove',
      surface: this.surfaceOf(chip) === 'sheet' ? 'sheet' : 'brand_row'
    });
    this.focusFallback = chip.id || '';
    this.syncBrand();
    this.flush({ reason: 'filter' });
  };

  // K15 / review A3: the head script (layout/theme.liquid) applied the remembered brand: say so once. The selected
  // chip above the grid is the visible cue; the flag is dropped on the first collection page either way.
  Controller.prototype.announceMemory = function () {
    var b = ssGet(SHOWN_KEY);
    if (b === null) return;
    ssDel(SHOWN_KEY);
    var vals = this.params.getAll(VENDOR_PARAM);
    var tpl = this.root.getAttribute('data-jl-msg-brand-shown') || '';
    if (vals.length !== 1 || vals[0] !== b || tpl.indexOf('JLBRAND') < 0 || !this.root.querySelector('[data-jl-brandrow]')) return;
    // after the page settles, so screen readers do not drop it while the page loads
    this.announce(tpl.replace('JLBRAND', b), 800);
  };

  Controller.prototype.onInstock = function (input) {
    var surface = 'toggle';
    if (!input.checked) {
      this.instockPending = false;
      if (!hasValue(this.params, AVAIL_PARAM, '1')) return;
      removeValue(this.params, AVAIL_PARAM, '1');
      this.params.delete('page');
      this.queueEvent('jl:filter-change', { param: AVAIL_PARAM, value: '1', action: 'remove', surface: surface });
      this.syncInputs();
      this.schedule('filter');
      return;
    }
    var sizes = this.params.getAll(SIZE_PARAM);
    var hasSizeGroup = !!this.root.querySelector('[data-jl-param="' + SIZE_PARAM + '"]');
    var remembered = this.validRemembered();
    if (sizes.length || remembered || !hasSizeGroup) {
      this.params.delete(AVAIL_PARAM);
      this.params.append(AVAIL_PARAM, '1');
      this.params.delete('page');
      this.queueEvent('jl:filter-change', { param: AVAIL_PARAM, value: '1', action: 'add', surface: surface });
      if (!sizes.length && remembered) {
        this.params.append(SIZE_PARAM, remembered);
        this.queueEvent('jl:filter-change', { param: SIZE_PARAM, value: remembered, action: 'add', surface: surface });
      }
      this.syncInputs();
      this.schedule('filter');
      return;
    }
    // no size known: stays off, asks for a size, and the next size picked turns it on
    input.checked = false;
    this.syncInputs();
    this.announce(this.root.getAttribute('data-jl-msg-pick'));
    if (this.sheetOpen || !isDesk()) {
      var sheet = this.sheetEl();
      var group = sheet && sheet.querySelector('[data-jl-group="' + SIZE_PARAM + '"]');
      if (group) {
        this.setGroup(group, true);
        this.scrollSheetTo(group);
      }
    } else {
      this.openPop(SIZE_PARAM, true);
    }
    this.instockPending = true;
  };

  /* ---------- filter, sort and clear actions ---------- */
  Controller.prototype.changeValue = function (param, value, on, surface) {
    if (!param) return;
    if (on) {
      if (!hasValue(this.params, param, value)) this.params.append(param, value);
    } else {
      removeValue(this.params, param, value);
    }
    this.params.delete('page');
    this.queueEvent('jl:filter-change', { param: param, value: value, action: on ? 'add' : 'remove', surface: surface });
    if (param === SIZE_PARAM) {
      if (on && this.instockPending) {
        this.instockPending = false;
        if (!hasValue(this.params, AVAIL_PARAM, '1')) {
          this.params.delete(AVAIL_PARAM);
          this.params.append(AVAIL_PARAM, '1');
          this.queueEvent('jl:filter-change', { param: AVAIL_PARAM, value: '1', action: 'add', surface: 'toggle' });
        }
      }
      var sizes = this.params.getAll(SIZE_PARAM);
      if (sizes.length === 1) rememberSize(sizes[0]);
    }
    this.syncInputs();
    this.schedule('filter');
  };

  Controller.prototype.applyPrice = function (form) {
    var minI = form.querySelector('[data-jl-price="min"]');
    var maxI = form.querySelector('[data-jl-price="max"]');
    if (!minI || !maxI) return;
    var minP = minI.getAttribute('data-jl-param');
    var maxP = maxI.getAttribute('data-jl-param');
    var lo = cleanNum(minI.value);
    var hi = cleanNum(maxI.value);
    if (lo !== '' && hi !== '' && parseFloat(lo) > parseFloat(hi)) {
      var x = lo;
      lo = hi;
      hi = x;
    }
    var before = (this.params.get(minP) || '') + '|' + (this.params.get(maxP) || '');
    if (before === lo + '|' + hi) return;
    if (lo !== '') this.params.set(minP, lo); else this.params.delete(minP);
    if (hi !== '') this.params.set(maxP, hi); else this.params.delete(maxP);
    this.params.delete('page');
    this.queueEvent('jl:filter-change', {
      param: form.getAttribute('data-jl-price-form') || 'filter.v.price',
      value: lo + '-' + hi,
      action: lo !== '' || hi !== '' ? 'add' : 'remove',
      surface: this.surfaceOf(form)
    });
    this.flush({ reason: 'filter' });
  };

  Controller.prototype.removeGroup = function (param, btn) {
    var keys = groupKeys(this.params, param);
    if (!keys.length) return;
    var self = this;
    var value;
    if (keys.length && keys[0] !== param) {
      value = (this.params.get(param + '.gte') || '') + '-' + (this.params.get(param + '.lte') || '');
    } else {
      value = this.params.getAll(param).join(',');
    }
    keys.forEach(function (k) { self.params.delete(k); });
    this.params.delete('page');
    this.queueEvent('jl:filter-change', { param: param, value: value, action: 'remove', surface: this.surfaceOf(btn) });
    this.focusFallback = (btn.id || '').replace('jl-chip-x-', 'jl-chip-');
    this.syncInputs();
    this.flush({ reason: 'filter' });
  };

  // everything: also the brand (the empty-results button); Clear all and the sheet Clear keep filter.p.vendor (K14)
  Controller.prototype.clearAll = function (surface, keepId, everything) {
    var self = this;
    var keys = [];
    this.params.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0 && (everything || k !== VENDOR_PARAM) && keys.indexOf(k) < 0) keys.push(k);
    });
    // the page ends on All brands, so the brand memory goes too (review C1)
    if (keys.indexOf(VENDOR_PARAM) >= 0) ssDel(BRAND_KEY);
    this.instockPending = false;
    if (!keys.length) return;
    keys.forEach(function (k) { self.params.delete(k); });
    this.params.delete('page');
    this.queueEvent('jl:filter-change', { param: 'all', value: '', action: 'clear', surface: surface });
    if (keepId) {
      this.focusFallback = keepId;
    } else {
      var first = isDesk() ? this.root.querySelector('.jl-chipbar__left [data-jl-chip]') : this.root.querySelector('[data-jl-open-sheet]');
      this.focusFallback = first ? first.id : '';
    }
    this.syncInputs();
    this.flush({ reason: 'filter' });
  };

  Controller.prototype.setSort = function (value, surface, el) {
    if (!value) return;
    var inPop = surface === 'chip' && el && el.closest('[data-jl-pop]');
    var pointer = lastPointerAt > 0 && nowMs() - lastPointerAt < 1500;
    this.params.set('sort_by', value);
    this.params.delete('page');
    var radios = this.root.querySelectorAll('[data-jl-sort]');
    for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i].value === value;
    if (inPop && !pointer) {
      // arrow keys keep the popover open and each step applies at once (K9), but they make one choice: the first
      // step pushes a history entry, later ones replace it, and the sort event and the announcement wait for the
      // popover to close (endSortKeys)
      if (!this.sortKeys) this.sortKeys = { from: new URLSearchParams(window.location.search).get('sort_by') || '', pushed: false, surface: surface, live: '', ending: false };
    } else {
      this.sortKeys = null;
      this.queueEvent('jl:sort-change', { value: value, surface: surface });
      // a pointer pick closes the sort popover
      if (inPop) this.closePop(true);
    }
    this.flush({ reason: 'sort' });
  };

  // the sort popover closed after keyboard steps: one jl:sort-change (GA4 sort_applied) and one announcement, once the
  // last step has rendered; nothing when the sort ended where it started
  Controller.prototype.endSortKeys = function () {
    var keys = this.sortKeys;
    if (!keys) return;
    if (this.ctrl) {
      keys.ending = true;
      return;
    }
    this.sortKeys = null;
    var now = new URLSearchParams(window.location.search).get('sort_by') || '';
    if (!keys.pushed || now === keys.from) return;
    dispatch('jl:sort-change', { value: now, surface: keys.surface });
    this.announce(keys.live || this.root.getAttribute('data-jl-live-results'));
  };

  /* ---------- fetching and rendering ---------- */
  Controller.prototype.sectionUrl = function (params) {
    var base = window.location.pathname || this.root.getAttribute('data-url') || '/';
    var q = cloneParams(params);
    q.delete('section_id');
    var s = q.toString();
    return base + '?' + (s ? s + '&' : '') + 'section_id=' + encodeURIComponent(this.id);
  };

  Controller.prototype.fetchDoc = function (params, ctrl) {
    var url = this.sectionUrl(params);
    var parse = function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (!doc.querySelector('[data-jl-collection]')) throw new Error('no collection root');
      return doc;
    };
    var hit = cacheGet(url);
    if (hit !== null) {
      return new Promise(function (resolve) { resolve(parse(hit)); });
    }
    var opts = { credentials: 'same-origin' };
    if (ctrl && ctrl.signal) opts.signal = ctrl.signal;
    return window.fetch(url, opts).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (html) {
      var doc = parse(html);
      cachePut(url, html);
      return doc;
    });
  };

  Controller.prototype.abortAll = function () {
    if (this.ctrl) { this.ctrl.abort(); this.ctrl = null; }
    if (this.moreCtrl) { this.moreCtrl.abort(); this.moreCtrl = null; this.resetMoreBtn(); }
    if (this.restoreCtrl) { this.restoreCtrl.abort(); this.restoreCtrl = null; }
  };

  Controller.prototype.schedule = function (reason) {
    var self = this;
    this.reason = reason || 'filter';
    // a newer change makes any response in flight stale: drop it now so it cannot overwrite the pending inputs
    this.abortAll();
    clearTimeout(this.timer);
    this.timer = setTimeout(function () { self.flush({ reason: self.reason }); }, DEBOUNCE_MS);
  };

  // opts: reason, push (default true), force
  Controller.prototype.flush = function (opts) {
    opts = opts || {};
    clearTimeout(this.timer);
    this.timer = null;
    var self = this;
    var reason = opts.reason || this.reason || 'filter';
    var push = opts.push !== false;
    var target = stripParams(this.params);
    if (!opts.force && keyOf(target) === this.renderedKey) {
      // nothing changed in the end (a value checked and unchecked within the debounce)
      this.queue = [];
      this.setBusy(false);
      return Promise.resolve(false);
    }
    this.abortAll();
    var ctrl = this.ctrl = newCtrl();
    this.setBusy(true);
    return this.fetchDoc(target, ctrl).then(function (doc) {
      if (ctrl !== self.ctrl) return false;
      self.ctrl = null;
      var newRoot = doc.querySelector('[data-jl-collection]');
      self.renderedKey = keyOf(target);
      self.applyRegions(newRoot);
      var keys = reason === 'sort' ? self.sortKeys : null;
      if (push) {
        var url = pageUrl(target);
        if (url !== window.location.pathname + window.location.search) {
          try {
            if (keys && keys.pushed) window.history.replaceState({ jlColl: 1 }, '', url);
            else window.history.pushState({ jlColl: 1 }, '', url);
          } catch (e) { /* noop */ }
          if (keys) keys.pushed = true;
        }
        setScrollRestoration('auto');
        self.params = cloneParams(target);
      } else {
        self.params = new URLSearchParams(window.location.search);
      }
      var q = self.queue;
      self.queue = [];
      for (var i = 0; i < q.length; i++) dispatch(q[i].name, q[i].detail);
      if (keys) keys.live = self.root.getAttribute('data-jl-live-results');
      else self.announce(self.root.getAttribute('data-jl-live-results'));
      if (self.sortKeys && self.sortKeys.ending) self.endSortKeys();
      dispatch('jl:collection-render', { reason: reason, count: self.total() });
      return true;
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return false;
      if (ctrl !== self.ctrl) return false;
      if (window.console && console.warn) console.warn('[jl-collection] update failed', err);
      self.ctrl = null;
      self.setBusy(false);
      self.queue = [];
      if (!push) {
        // the browser already moved to another entry: load it for real
        window.location.reload();
        return false;
      }
      // state unchanged: the URL still holds the last rendered state
      self.params = new URLSearchParams(window.location.search);
      self.syncInputs();
      self.announce(self.root.getAttribute('data-jl-msg-update-error'));
      self.toast(self.root.getAttribute('data-jl-msg-update-error'));
      if (self.sortKeys && self.sortKeys.ending) self.endSortKeys();
      return false;
    });
  };

  Controller.prototype.replaceRegion = function (name, newRoot, next) {
    var cur = this.root.querySelector('[data-jl-region="' + name + '"]');
    if (next === undefined) next = newRoot.querySelector('[data-jl-region="' + name + '"]');
    if (!cur || !next) return null;
    var node = document.importNode(next, true);
    cur.parentNode.replaceChild(node, cur);
    return node;
  };

  Controller.prototype.applyRegions = function (newRoot) {
    var self = this;
    var root = this.root;
    var active = document.activeElement;
    var activeId = active && active !== document.body && root.contains(active) ? active.id : '';
    var sheet = this.sheetEl();
    var groups = null;
    var bodyTop = 0;
    var i;
    if (this.sheetOpen && sheet) {
      groups = {};
      var gb = sheet.querySelectorAll('[data-jl-group]');
      for (i = 0; i < gb.length; i++) groups[gb[i].getAttribute('data-jl-group')] = gb[i].getAttribute('aria-expanded') === 'true';
      var body = sheet.querySelector('[data-jl-sheet-body]');
      bodyTop = body ? body.scrollTop : 0;
    }
    var pop = this.popParam;
    var popEl = pop ? this.popFor(pop) : null;
    var popTop = popEl ? popEl.scrollTop : 0;
    var oldBrand = root.querySelector('.jl-brandrow--row');
    var brandLeft = oldBrand ? oldBrand.scrollLeft : 0;
    var oldPill = root.querySelector('[data-jl-filter-pill]');
    var pillVisible = !!(oldPill && oldPill.classList.contains('is-visible'));

    COPY_ATTRS.forEach(function (a) {
      if (newRoot.hasAttribute(a)) root.setAttribute(a, newRoot.getAttribute(a));
    });

    REGIONS.forEach(function (name) {
      var next = newRoot.querySelector('[data-jl-region="' + name + '"]');
      if (name === 'pill' && next && pillVisible) {
        var np = next.querySelector('[data-jl-filter-pill]');
        if (np) np.classList.add('is-visible');
      }
      self.replaceRegion(name, newRoot, next);
    });
    if (this.sheetOpen) this.stampSheet();
    // the phone brand row scrolls sideways: keep where the shopper left it
    var newBrand = brandLeft ? root.querySelector('.jl-brandrow--row') : null;
    if (newBrand) newBrand.scrollLeft = brandLeft;

    if (groups) {
      sheet = this.sheetEl();
      var nb = sheet ? sheet.querySelectorAll('[data-jl-group]') : [];
      for (i = 0; i < nb.length; i++) {
        var p = nb[i].getAttribute('data-jl-group');
        if (Object.prototype.hasOwnProperty.call(groups, p)) this.setGroup(nb[i], groups[p]);
      }
      var nbody = sheet && sheet.querySelector('[data-jl-sheet-body]');
      if (nbody) nbody.scrollTop = bodyTop;
      // replaced siblings came back without inert: apply it again
      this.inertPage(false);
      this.inertPage(true);
    }

    this.popParam = null;
    if (pop && isDesk() && !this.sheetOpen) {
      // the list stays where the shopper scrolled it, so the ticked row stays in view (P10)
      this.openPop(pop, false);
      var newPop = this.popFor(pop);
      if (newPop && popTop) newPop.scrollTop = popTop;
    }

    var target = activeId ? document.getElementById(activeId) : null;
    if (!visible(target) && this.focusFallback) target = document.getElementById(this.focusFallback);
    this.focusFallback = '';
    if (visible(target) && !target.closest('[inert]')) {
      focusEl(target);
    } else if (activeId && this.sheetOpen) {
      focusEl(this.sheetFocusables()[0]);
    } else if (activeId && pop) {
      focusEl(this.chipFor(pop));
    }

    this.syncCols();
    this.syncChipAria();
    this.syncInstock();
    this.applyHold();
    this.observeMore();
    this.updatePill();
    this.toast('');
    this.setBusy(false);
  };

  /* ---------- K6 load more ---------- */
  Controller.prototype.resetMoreBtn = function () {
    var b = this.root.querySelector('[data-jl-more-btn]');
    if (!b) return;
    b.removeAttribute('aria-disabled');
    b.removeAttribute('aria-busy');
  };

  Controller.prototype.loadMore = function (btn) {
    if (this.moreCtrl || this.ctrl || this.timer || this.restoreCtrl) return;
    var next = this.highestPage() + 1;
    if (next > int(this.root.getAttribute('data-pages'), 1)) return;
    var self = this;
    var ctrl = this.moreCtrl = newCtrl();
    var q = stripParams(this.params);
    q.set('page', String(next));
    var grid = this.grid();
    var held = grid ? grid.querySelector('[data-jl-hold]') : null;
    // aria-disabled, not disabled: the button keeps focus while the page loads (this.moreCtrl blocks a second click)
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-busy', 'true');
    this.fetchDoc(q, ctrl).then(function (doc) {
      if (ctrl !== self.moreCtrl) return;
      self.moreCtrl = null;
      var r = doc.querySelector('[data-jl-collection]');
      grid = self.grid();
      if (!grid) return;
      var cells = r.querySelectorAll('[data-jl-grid] > .jl-grid__item');
      var frag = document.createDocumentFragment();
      var first = null;
      for (var i = 0; i < cells.length; i++) {
        var n = document.importNode(cells[i], true);
        n.removeAttribute('data-jl-hold');
        if (!first) first = n;
        frag.appendChild(n);
      }
      self.syncSizes(frag);
      grid.appendChild(frag);
      ['data-total', 'data-pages', 'data-has-tile', 'data-jl-live-results'].forEach(function (a) {
        if (r.hasAttribute(a)) self.root.setAttribute(a, r.getAttribute(a));
      });
      self.root.setAttribute('data-page', String(next));
      self.applyHold();
      self.replaceRegion('more', r);
      self.observeMore();

      var p = stripParams(self.params);
      p.set('page', String(next));
      try { window.history.replaceState(window.history.state, '', pageUrl(p)); } catch (e) { /* noop */ }
      setScrollRestoration('manual');
      self.params = p;

      var desk = isDesk();
      var target = desk && held && document.documentElement.contains(held) && !held.hasAttribute('data-jl-hold') ? held : first;
      var link = target && (target.querySelector('.jl-card__link') || target.querySelector('a[href*="/products/"]') || target.querySelector('a[href]'));
      focusEl(link, true);

      var more = self.root.querySelector('[data-jl-more]');
      var seen = more ? int(more.getAttribute(desk ? 'data-seen-held' : 'data-seen-all'), 0) : 0;
      self.announce(more && more.getAttribute(desk ? 'data-jl-seen-held' : 'data-jl-seen-all'));
      self.updatePill();
      dispatch('jl:load-more', { page: next, seen: seen, total: self.total() });
      dispatch('jl:collection-render', { reason: 'load-more', count: self.total() });
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      if (ctrl !== self.moreCtrl) return;
      self.moreCtrl = null;
      self.resetMoreBtn();
      var b = self.root.querySelector('[data-jl-more-btn]');
      if (b && (!document.activeElement || document.activeElement === document.body)) focusEl(b);
      self.announce(self.root.getAttribute('data-jl-msg-load-error'));
    });
  };

  // fetch several pages at once and insert their cells in page order. mode 'prepend' (K6 restore: page 1 brings the
  // tile) or 'append' (popstate back to a page=N entry). Resolves true when inserted.
  Controller.prototype.loadPages = function (list, mode) {
    var self = this;
    if (!list.length) return Promise.resolve(true);
    if (this.restoreCtrl) this.restoreCtrl.abort();
    var ctrl = this.restoreCtrl = newCtrl();
    var base = stripParams(this.params);
    var prev = this.root.querySelector('.jl-prev');
    var reqs = list.map(function (n) {
      var q = cloneParams(base);
      if (n > 1) q.set('page', String(n));
      return self.fetchDoc(q, ctrl);
    });
    this.setBusy(true);
    return Promise.all(reqs).then(function (docs) {
      if (ctrl !== self.restoreCtrl) return false;
      self.restoreCtrl = null;
      var grid = self.grid();
      if (!grid) { self.setBusy(false); return false; }
      var frag = document.createDocumentFragment();
      var lastRoot = null;
      docs.forEach(function (doc) {
        var r = doc.querySelector('[data-jl-collection]');
        lastRoot = r;
        var cells = r.querySelectorAll('[data-jl-grid] > li');
        for (var i = 0; i < cells.length; i++) {
          if (mode === 'append' && cells[i].hasAttribute('data-jl-tile')) continue;
          var n = document.importNode(cells[i], true);
          n.removeAttribute('data-jl-hold');
          frag.appendChild(n);
        }
      });
      self.syncSizes(frag);
      if (mode === 'prepend') {
        var anchor = grid.querySelector('.jl-grid__item');
        var before = anchor ? anchor.getBoundingClientRect().top : 0;
        grid.insertBefore(frag, grid.firstChild);
        if (prev && prev.parentNode) prev.parentNode.removeChild(prev);
        self.applyHold();
        // keep what was on screen where it was (no jump while the earlier pages arrive above it)
        if (anchor) {
          var delta = anchor.getBoundingClientRect().top - before;
          if (Math.abs(delta) >= 1) jumpTo((window.pageYOffset || 0) + delta);
        }
      } else {
        grid.appendChild(frag);
        self.root.setAttribute('data-page', String(list[list.length - 1]));
        self.applyHold();
        if (lastRoot) self.replaceRegion('more', lastRoot);
        self.observeMore();
      }
      self.setBusy(false);
      self.updatePill();
      return true;
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return false;
      if (ctrl !== self.restoreCtrl) return false;
      self.restoreCtrl = null;
      self.setBusy(false);
      if (prev) prev.classList.add('is-shown');
      return false;
    });
  };

  // K6: landing on page=N > 1 brings pages 1 to N-1 back, then the saved position (back/forward and reload)
  Controller.prototype.restore = function () {
    var page = int(this.root.getAttribute('data-page'), 1);
    if (page <= 1 || this.root.getAttribute('data-load-more') !== 'true' || !this.grid()) return;
    var last = Math.min(page - 1, int(this.root.getAttribute('data-pages'), 1), MAX_RESTORE_PAGES);
    var list = [];
    for (var n = 1; n <= last; n++) list.push(n);
    var self = this;
    var nav = navType();
    var saved = nav === 'back_forward' || nav === 'reload' ? this.readPos() : null;
    this.loadPages(list, 'prepend').then(function (ok) {
      if (!ok) return;
      if (saved && int(saved.page, 0) === self.highestPage()) self.scrollToSaved(saved);
      dispatch('jl:collection-render', { reason: 'restore', count: self.total() });
    });
  };

  Controller.prototype.posKey = function () {
    var s = stripParams(new URLSearchParams(window.location.search)).toString();
    return POS_KEY + window.location.pathname + (s ? '?' + s : '');
  };

  Controller.prototype.readPos = function () {
    var raw = ssGet(this.posKey());
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  };

  Controller.prototype.firstVisibleItem = function () {
    var grid = this.grid();
    if (!grid) return null;
    var top = int(window.getComputedStyle(document.documentElement).getPropertyValue('--jl-header-h'), 0);
    var items = grid.querySelectorAll('.jl-grid__item');
    for (var i = 0; i < items.length; i++) {
      if (!visible(items[i])) continue;
      if (items[i].getBoundingClientRect().bottom > top) return items[i];
    }
    return null;
  };

  Controller.prototype.savePos = function (item) {
    if (!this.grid()) return;
    if (!item) item = this.firstVisibleItem();
    var card = item ? item.querySelector('[data-handle]') : null;
    var data = {
      page: this.highestPage(),
      handle: card ? card.getAttribute('data-handle') || '' : '',
      y: Math.round(window.pageYOffset || document.documentElement.scrollTop || 0)
    };
    if (item) data.top = Math.round(item.getBoundingClientRect().top);
    ssSet(this.posKey(), JSON.stringify(data));
  };

  Controller.prototype.scrollToSaved = function (saved) {
    var grid = this.grid();
    var card = grid && saved.handle ? grid.querySelector('.jl-grid__item [data-handle="' + cssEsc(saved.handle) + '"]') : null;
    var item = card ? card.closest('.jl-grid__item') : null;
    if (item && visible(item)) {
      jumpTo((window.pageYOffset || 0) + item.getBoundingClientRect().top - (typeof saved.top === 'number' ? saved.top : 0));
    } else if (typeof saved.y === 'number') {
      jumpTo(saved.y);
    }
  };

  // popstate: render the entry's state without pushing; a page=N entry gets its later pages appended
  Controller.prototype.onPopState = function () {
    var params = new URLSearchParams(window.location.search);
    var key = keyOf(params);
    // a hash change or the entry already pending: nothing to do
    if (key === keyOf(this.params)) return;
    var page = int(params.get('page'), 1);
    var self = this;
    clearTimeout(this.timer);
    this.timer = null;
    this.queue = [];
    this.instockPending = false;
    this.sortKeys = null;
    if (this.ctrl) {
      this.ctrl.abort();
      this.ctrl = null;
      this.setBusy(false);
    }
    if (key === this.renderedKey) {
      // back to what is on screen while a change was still pending: drop the change
      this.params = params;
      this.syncInputs();
      return;
    }
    this.closePop(false);
    this.params = params;
    this.flush({ reason: 'popstate', push: false, force: true }).then(function (ok) {
      if (!ok || page <= 1) return;
      var last = Math.min(page, int(self.root.getAttribute('data-pages'), 1), MAX_RESTORE_PAGES);
      var list = [];
      for (var n = 2; n <= last; n++) list.push(n);
      self.loadPages(list, 'append').then(function (done) {
        if (done && list.length) dispatch('jl:collection-render', { reason: 'popstate', count: self.total() });
      });
    });
  };

  /* ---------- popovers (>= 768) ---------- */
  Controller.prototype.chipFor = function (param) {
    return this.root.querySelector('[data-jl-chip="' + cssEsc(param) + '"]');
  };

  Controller.prototype.popFor = function (param) {
    return this.root.querySelector('[data-jl-pop="' + cssEsc(param) + '"]');
  };

  Controller.prototype.openPop = function (param, focusInside) {
    if (this.popParam && this.popParam !== param) this.closePop(false);
    var chip = this.chipFor(param);
    var pop = this.popFor(param);
    if (!chip || !pop) return;
    pop.hidden = false;
    chip.setAttribute('aria-expanded', 'true');
    this.popParam = param;
    pop.classList.remove('is-flipped');
    if (!pop.classList.contains('jl-pop--sort')) {
      var vw = document.documentElement.clientWidth || window.innerWidth;
      if (pop.getBoundingClientRect().right > vw - 8) pop.classList.add('is-flipped');
    }
    if (focusInside) {
      var first = param === 'sort_by' ? pop.querySelector('input:checked') : null;
      focusEl(first || pop.querySelector('input:not([disabled]), button:not([disabled])'));
    }
  };

  Controller.prototype.closePop = function (restoreFocus) {
    var param = this.popParam;
    if (!param) return;
    this.popParam = null;
    var chip = this.chipFor(param);
    var pop = this.popFor(param);
    if (pop) pop.hidden = true;
    if (chip) chip.setAttribute('aria-expanded', 'false');
    if (param === SIZE_PARAM && !this.sheetOpen) this.instockPending = false;
    if (restoreFocus && chip) focusEl(chip);
    if (param === 'sort_by') this.endSortKeys();
  };

  Controller.prototype.popWrap = function () {
    var pop = this.popParam ? this.popFor(this.popParam) : null;
    return pop ? (pop.closest('[data-jl-chipwrap]') || pop) : null;
  };

  Controller.prototype.onChip = function (chip) {
    var param = chip.getAttribute('data-jl-chip');
    if (!isDesk()) {
      this.openSheet('chip', chip, param);
      return;
    }
    if (this.popParam === param) this.closePop(true);
    else this.openPop(param, true);
  };

  /* ---------- filter sheet (< 768, collection:M4) ---------- */
  Controller.prototype.sheetEl = function () {
    return this.root.querySelector('[data-jl-filter-sheet]');
  };

  // the sheet body ships in a <template> (no DOM until needed): stamped on open and after a re-render while open
  Controller.prototype.stampSheet = function () {
    var sheet = this.sheetEl();
    var tpl = sheet && sheet.querySelector('template[data-jl-sheet-tpl]');
    if (!tpl) return;
    tpl.parentNode.replaceChild(document.importNode(tpl.content, true), tpl);
    this.syncInputs();
  };

  // >= 768 a group chip controls its popover (aria-expanded); below it opens the sheet: aria-controls names the sheet
  // and there is no expanded state to report
  Controller.prototype.syncChipAria = function () {
    var desk = isDesk();
    var sheet = this.sheetEl();
    var chips = this.root.querySelectorAll('.jl-chipbar__left [data-jl-chip]');
    for (var i = 0; i < chips.length; i++) {
      var param = chips[i].getAttribute('data-jl-chip');
      var pop = this.popFor(param);
      if (desk) {
        if (pop && pop.id) chips[i].setAttribute('aria-controls', pop.id);
        chips[i].setAttribute('aria-expanded', this.popParam === param ? 'true' : 'false');
      } else {
        if (sheet && sheet.id) chips[i].setAttribute('aria-controls', sheet.id);
        else chips[i].removeAttribute('aria-controls');
        chips[i].removeAttribute('aria-expanded');
      }
    }
  };

  Controller.prototype.sheetFocusables = function () {
    var sheet = this.sheetEl();
    if (!sheet) return [];
    var panel = sheet.querySelector('.jl-fsheet__panel') || sheet;
    var list = panel.querySelectorAll(FOCUSABLE);
    var out = [];
    for (var i = 0; i < list.length; i++) if (visible(list[i])) out.push(list[i]);
    return out;
  };

  Controller.prototype.setGroup = function (btn, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var opts = document.getElementById(btn.getAttribute('aria-controls') || '');
    if (opts) opts.hidden = !open;
  };

  Controller.prototype.scrollSheetTo = function (groupBtn) {
    var sheet = this.sheetEl();
    var body = sheet && sheet.querySelector('[data-jl-sheet-body]');
    var sect = groupBtn.closest('.jl-fsheet__sect') || groupBtn;
    if (!body) return;
    body.scrollTop += sect.getBoundingClientRect().top - body.getBoundingClientRect().top;
  };

  Controller.prototype.openSheet = function (source, opener, group) {
    var sheet = this.sheetEl();
    if (!sheet || this.sheetOpen) return;
    this.stampSheet();
    this.closePop(false);
    try {
      if (window.JLSizeSheet && typeof window.JLSizeSheet.isOpen === 'function' && window.JLSizeSheet.isOpen()) {
        window.JLSizeSheet.close({ restoreFocus: false, reason: 'other-sheet' });
      }
    } catch (e) { /* SHEET not ready */ }
    this.sheetOpener = opener || document.activeElement;
    this.sheetOpenerId = (this.sheetOpener && this.sheetOpener.id) || '';
    var groupBtn = group ? sheet.querySelector('[data-jl-group="' + cssEsc(group) + '"]') : null;
    if (groupBtn) this.setGroup(groupBtn, true);
    sheet.hidden = false;
    this.sheetOpen = true;
    document.body.classList.add('jl-fsheet-open');
    this.inertPage(true);
    // focus moves synchronously inside the tap (iOS keeps VoiceOver and the keyboard in the sheet)
    focusEl(groupBtn || sheet.querySelector('[data-jl-group]') || this.sheetFocusables()[0]);
    if (groupBtn) this.scrollSheetTo(groupBtn);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (!sheet.hidden) sheet.classList.add('is-open');
      });
    });
    this.updatePill();
    dispatch('jl:filter-sheet-open', { source: source });
  };

  Controller.prototype.closeSheet = function (restore) {
    var sheet = this.sheetEl();
    if (!this.sheetOpen) return;
    this.sheetOpen = false;
    if (sheet) {
      sheet.classList.remove('is-open');
      sheet.hidden = true;
    }
    document.body.classList.remove('jl-fsheet-open');
    this.inertPage(false);
    this.instockPending = false;
    var opener = (this.sheetOpenerId && document.getElementById(this.sheetOpenerId)) || this.sheetOpener;
    this.sheetOpener = null;
    this.sheetOpenerId = '';
    this.updatePill();
    if (restore !== false && opener && visible(opener) && !opener.closest('[inert]')) focusEl(opener);
  };

  Controller.prototype.onShowResults = function () {
    if (this.timer) this.flush({ reason: this.reason });
    this.closeSheet(true);
  };

  // phase 3 algorithm: every sibling up the ancestor chain is inert while the sheet is open; only what this set is
  // released. The live region stays reachable so result counts are still announced.
  Controller.prototype.inertPage = function (on) {
    var list = this.inerted || [];
    var i;
    if (!on) {
      for (i = 0; i < list.length; i++) list[i].removeAttribute('inert');
      this.inerted = [];
      return;
    }
    if (list.length) return;
    var sheet = this.sheetEl();
    if (!sheet) return;
    for (var el = sheet; el && el.parentElement && el !== document.body; el = el.parentElement) {
      var kids = el.parentElement.children;
      for (i = 0; i < kids.length; i++) {
        var k = kids[i];
        if (k === el || SKIP_INERT.test(k.tagName) || k.hasAttribute('inert') || k.hasAttribute('data-jl-live')) continue;
        k.setAttribute('inert', '');
        list.push(k);
      }
    }
    this.inerted = list;
  };

  Controller.prototype.onSheetKey = function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      e.stopPropagation();
      this.closeSheet(true);
      return;
    }
    if (e.key !== 'Tab') return;
    var sheet = this.sheetEl();
    var panel = sheet && (sheet.querySelector('.jl-fsheet__panel') || sheet);
    var f = this.sheetFocusables();
    if (!panel || !f.length) {
      e.preventDefault();
      return;
    }
    var first = f[0];
    var last = f[f.length - 1];
    var active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !panel.contains(active)) {
        e.preventDefault();
        focusEl(last);
      }
    } else if (active === last || !panel.contains(active)) {
      e.preventDefault();
      focusEl(first);
    }
  };

  /* ---------- M4 pill visibility ---------- */
  Controller.prototype.observePill = function () {
    var self = this;
    if (typeof window.IntersectionObserver !== 'function') return;
    this.io = new window.IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var en = entries[i];
        if (en.target === self.sentinel) self.pill.past = !en.isIntersecting && en.boundingClientRect.top < 0;
        else if (en.target === self.moreEl) self.pill.more = en.isIntersecting;
        else if (en.target === self.footer) self.pill.footer = en.isIntersecting;
      }
      self.updatePill();
    });
    this.sentinel = this.root.querySelector('[data-jl-chipbar-end]');
    if (this.sentinel) this.io.observe(this.sentinel);
    this.footer = document.querySelector('.shopify-section-group-footer-group') ||
      document.getElementById('shopify-section-footer') || document.querySelector('footer');
    if (this.footer && !this.root.contains(this.footer)) this.io.observe(this.footer);
    else this.footer = null;
    this.observeMore();
  };

  Controller.prototype.observeMore = function () {
    var el = this.root.querySelector('[data-jl-more]');
    if (el === this.moreEl) return;
    if (this.io && this.moreEl) this.io.unobserve(this.moreEl);
    this.moreEl = el;
    this.pill.more = false;
    if (this.io && el) this.io.observe(el);
  };

  Controller.prototype.updatePill = function () {
    var pill = this.root.querySelector('[data-jl-filter-pill]');
    if (!pill) return;
    var b = document.body.classList;
    var show = this.pill.past && !this.pill.more && !this.pill.footer && !this.sheetOpen && !!this.sheetEl() &&
      !b.contains('jl-fsheet-open') && !b.contains('cart-drawer-is-open') && !b.contains('jl-qa-open') && !b.contains('jl-sheet-open');
    pill.classList.toggle('is-visible', show);
    // keyboard focus scrolled into view stays above the pill (scroll-padding-bottom in jl-collection.css, phones only)
    document.documentElement.classList.toggle('jl-pill-on', show);
  };

  /* ---------- delegated events ---------- */
  Controller.prototype.onClick = function (e, t) {
    var el;
    if ((el = t.closest('[data-jl-more-btn]'))) {
      e.preventDefault();
      this.loadMore(el);
      return;
    }
    if ((el = t.closest('[data-jl-cols-toggle] [data-cols]'))) {
      this.setCols(el.getAttribute('data-cols'));
      return;
    }
    if ((el = t.closest('.jl-bchip[data-jl-brand]'))) {
      this.onBrand(e, el);
      return;
    }
    if ((el = t.closest('[data-jl-chip-remove]'))) {
      this.removeGroup(el.getAttribute('data-jl-chip-remove'), el);
      return;
    }
    if ((el = t.closest('[data-jl-open-sheet]'))) {
      this.openSheet('filter', el);
      return;
    }
    if ((el = t.closest('[data-jl-filter-pill]'))) {
      this.openSheet('pill', el);
      return;
    }
    if ((el = t.closest('[data-jl-chip]'))) {
      this.onChip(el);
      return;
    }
    if ((el = t.closest('[data-jl-sheet-close]'))) {
      this.closeSheet(true);
      return;
    }
    if ((el = t.closest('[data-jl-show-results]'))) {
      this.onShowResults();
      return;
    }
    if ((el = t.closest('[data-jl-sheet-clear]'))) {
      if (el.getAttribute('aria-disabled') !== 'true') this.clearAll('sheet', el.id);
      return;
    }
    if ((el = t.closest('[data-jl-clear-all]'))) {
      this.clearAll(this.surfaceOf(el), '', el.getAttribute('data-jl-clear-all') === 'everything');
      return;
    }
    if ((el = t.closest('[data-jl-group]'))) {
      this.setGroup(el, el.getAttribute('aria-expanded') !== 'true');
      return;
    }
    if ((el = t.closest('.jl-szchip[data-jl-param]'))) {
      var on = el.getAttribute('aria-pressed') !== 'true';
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      this.changeValue(el.getAttribute('data-jl-param'), el.getAttribute('value') || '', on, this.surfaceOf(el));
      return;
    }
    el = t.closest('a[href]');
    if (el && el.closest('[data-jl-grid]') && /\/products\//.test(el.getAttribute('href') || '')) {
      this.savePos(el.closest('.jl-grid__item'));
      this.clickSavedAt = Date.now();
    }
  };

  Controller.prototype.onChange = function (t) {
    if (t.matches('[data-jl-instock]')) {
      this.onInstock(t);
      return;
    }
    if (t.matches('[data-jl-sort]')) {
      if (t.checked) this.setSort(t.value, this.surfaceOf(t), t);
      return;
    }
    if (t.matches('input[type="checkbox"][data-jl-param]')) {
      this.changeValue(t.getAttribute('data-jl-param'), t.getAttribute('value') || '', t.checked, this.surfaceOf(t));
    }
  };

  function controllerFor(el) {
    var root = el && el.closest ? el.closest('[data-jl-collection]') : null;
    if (!root) return null;
    for (var i = 0; i < controllers.length; i++) if (controllers[i].root === root) return controllers[i];
    return null;
  }

  document.addEventListener('pointerdown', function () { lastPointerAt = nowMs(); }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // an outside click closes an open popover (focus stays where the click went)
    for (var i = 0; i < controllers.length; i++) {
      var w = controllers[i].popWrap();
      if (w && !w.contains(t)) controllers[i].closePop(false);
    }
    var c = controllerFor(t);
    if (c) c.onClick(e, t);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    var c = controllerFor(t);
    if (c && t.matches) c.onChange(t);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var c = controllerFor(form);
    if (!c || !form.matches) return;
    if (form.matches('[data-jl-price-form]')) {
      e.preventDefault();
      c.applyPrice(form);
    } else if (form.matches('[data-jl-sort-form]')) {
      e.preventDefault();
      // Enter on a sort option: done choosing (closes the popover, focus back to the chip)
      if (c.popParam === 'sort_by' && form.closest('[data-jl-pop]')) c.closePop(true);
    }
  });

  // capture: Escape is handled (and swallowed) before page-level listeners while a sheet or popover is open
  document.addEventListener('keydown', function (e) {
    for (var i = 0; i < controllers.length; i++) {
      var c = controllers[i];
      if (c.sheetOpen) {
        c.onSheetKey(e);
        return;
      }
      if (c.popParam && (e.key === 'Escape' || e.key === 'Esc')) {
        e.preventDefault();
        e.stopPropagation();
        c.closePop(true);
        return;
      }
    }
  }, true);

  // focus leaving an open popover closes it. Focus that lands on an ANCESTOR is not leaving it: a press on an option's
  // label text focuses main#MainContent[tabindex=-1] (any control in Safari), and closing there lost the click (P10)
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    for (var i = 0; i < controllers.length; i++) {
      var w = controllers[i].popWrap();
      if (w && t && !w.contains(t) && !(t.contains && t.contains(w))) controllers[i].closePop(false);
    }
  });

  window.addEventListener('popstate', function () {
    for (var i = 0; i < controllers.length; i++) controllers[i].onPopState();
  });

  window.addEventListener('pagehide', function () {
    for (var i = 0; i < controllers.length; i++) {
      if (Date.now() - controllers[i].clickSavedAt > 5000) controllers[i].savePos();
    }
  });

  window.addEventListener('resize', queueHeader);

  // the bag changed: section responses are fetched fresh again
  document.addEventListener('jl:quick-add', function () { cache = []; });

  // a page restored from the back/forward cache may be older than the shopper's bag or currency: fetch fresh
  window.addEventListener('pageshow', function (e) { if (e.persisted) cache = []; });

  // never open together with the size sheet (SHEET)
  document.addEventListener('jl:size-sheet-open', function () {
    for (var i = 0; i < controllers.length; i++) controllers[i].closeSheet(false);
  });

  function onBreakpoint() {
    var desk = isDesk();
    for (var i = 0; i < controllers.length; i++) {
      if (desk) controllers[i].closeSheet(false);
      else controllers[i].closePop(false);
      controllers[i].syncChipAria();
      controllers[i].updatePill();
    }
    queueHeader();
  }
  if (deskMq) {
    if (typeof deskMq.addEventListener === 'function') deskMq.addEventListener('change', onBreakpoint);
    else if (typeof deskMq.addListener === 'function') deskMq.addListener(onBreakpoint);
  }

  // the bag, the size sheet and the phase 3 sheet hide the pill (body classes)
  if (typeof window.MutationObserver === 'function' && document.body) {
    new window.MutationObserver(function () {
      for (var i = 0; i < controllers.length; i++) controllers[i].updatePill();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- boot and theme editor (K34) ---------- */
  function prune() {
    controllers = controllers.filter(function (c) {
      if (document.documentElement.contains(c.root)) return true;
      c.destroy();
      return false;
    });
  }

  function scan(scope) {
    prune();
    var roots = (scope || document).querySelectorAll('[data-jl-collection]');
    var created = false;
    for (var i = 0; i < roots.length; i++) {
      var known = false;
      for (var j = 0; j < controllers.length; j++) if (controllers[j].root === roots[i]) known = true;
      if (!known) {
        controllers.push(new Controller(roots[i]));
        created = true;
      }
    }
    if (created || scope) watchHeader();
  }

  document.addEventListener('shopify:section:load', function (e) {
    cache = []; // the theme editor changed the section's settings: responses rendered before are stale
    scan(e.target && e.target.querySelectorAll ? e.target : document);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var scope = e.target;
    controllers = controllers.filter(function (c) {
      if (scope && scope.contains && scope.contains(c.root)) {
        c.destroy();
        return false;
      }
      return true;
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})();
